import React, {Component} from 'react';
import { connect } from "react-redux";
import Footer from "../Main/Footer"
import Loading from "../../Components/loading/loading"
import {config} from "../../Reducers/auth/actions"
class Account extends Component {
  componentWillMount() {
    this.props.config();
  }
  render() {
    return (<div className="content-page login-background_recreatie">
      <div className="content-wrapper fullscreen transpbackground">
        <div className="login-box">
          <div className="login-logo">
          <img src="/brand/logo.png" alt='Logo recraplan' width={300}/>
          </div>
          <section className="content">
            <Loading/>
            {this.props.children}
          </section>
          {/* /.content */}
        </div>
      </div>
    <Footer className="main-footer fullscreen"/>
    </div>);
  }
};

function mapStateToProps(state) {
  return { config: state.auth.config };
}

export default connect(
  mapStateToProps,
  { config }
)(Account);
